import { action, observable, makeObservable } from 'mobx';
import {ContentLookup, SuccessResponse} from '../../../../domain';
import {HttpPromiseState} from '../../../../lib/helpers';
import {ClassroomLoaders} from '../../../classroom/stores/classroom-loaders';
import {AdminClassroomSceneStore} from '../AdminClassroomSceneStore';
import {ClassroomEditFormStore} from './ClassroomEditFormStore';

export class ClassroomAddStore {
  form: ClassroomEditFormStore;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly parent: AdminClassroomSceneStore,
              private readonly lookup: ContentLookup) {
    makeObservable(this);
    this.form = new ClassroomEditFormStore(lookup);
    this.form.setStartTime(Date.now() / 1000);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.form.markAllTouched();
    if (!this.form.valid)
      return;
    this.save = ClassroomLoaders.Admin.createClassroom(this.form.model);
  }

  dispose = () => {
    this.form.dispose();
  };
}
